(function LoginAs($, Adzuki)
{
	"use strict";

	var _init;

	_init = function _init()
	{
		// SET-58: DELEGATED, not bound to the elements present at ready.
		//
		// The owner list on Franchise Profile carries these links, and in the settings modal that
		// list arrives by AJAX long after this ran - so a direct binding left the link with no
		// handler at all, and clicking it followed href="/loginAs" and navigated the host page
		// away, taking the modal and any unsaved edits with it.
		//
		// Delegation is also just the correct binding for a control that can be injected: nothing
		// else about the handler changes, and every existing caller keeps working.
		//
		// 'a.login-as', NOT '.login-as', AND THE TAG NAME IS LOAD-BEARING. Line 44 below puts the
		// SAME CLASS on .modal-dialog to style the open dialog (_modal.scss), so a delegated
		// '.login-as' matched the dialog too - every click inside it, including its own "Login as
		// agent" button, bubbled up, re-entered this handler with `this` as the dialog, read no
		// data-agent-id and requested /Agents/getLoginAsModal/undefined. That found no agent row
		// and surfaced as "Undefined index: franchise_id" in AgentsController.
		//
		// The direct binding it replaced never hit this, because the dialog gains the class long
		// after document ready. Every trigger is an anchor - they all come from
		// HtmlComponent::iconLink() - so the tag name is the reliable way to tell the control
		// from the container that borrows its class.
		$(document).on('click', 'a.login-as', function loginAs(e) {
			// SET-58: #modalWindow, NOT '.modal'. The class matches every modal on the page, and
			// .modal('show') on a set of them shows all of them - each with its own backdrop, so
			// dismissing the one in front leaves the rest of the backdrops dimming the screen. It
			// also wrote the title and body into all of them. #modalWindow is the framework's one
			// shared dialog container and the only one this was ever meant to use.
			var $modal         = $('#modalWindow'),
			    $link          = $(this),
			    message        = 'Click the link below to login as the selected agent.',
			    text           = 'Login as agent',
			    login_link_uri = '/Agents/getLoginAsModal/' + $link.data('agent-id'),
			    timer_timeout;

			if (typeof $link.data('message') !== 'undefined') {
				message = $link.data('message');
			}

			if (typeof $link.data('text') !== 'undefined') {
				text = $link.data('text');
			}

			if (typeof $link.data('app') !== 'undefined') {
				login_link_uri += '/' + $link.data('app');

				if (typeof $link.data('uri') !== 'undefined') {
					login_link_uri += '/' + encodeURIComponent($link.data('uri'));
				}
			}

			e.preventDefault();

			$modal.find('.modal-dialog').addClass('login-as');
			$modal.find('.modal-title').text('Login as Agent');
			$modal.find('.modal-body').html('Retrieving "Login as" link...');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				clearTimeout(timer_timeout);

				$modal.find('.modal-dialog').removeClass('login-as');
				$modal.off('hidden.bs.modal');
			});

			$modal.modal('show');

			Adzuki.Ajax.get(login_link_uri).then(function success(response) {
				var timer,
				    time_remaining = 20;

				$modal.find('.modal-body').html(response);

				if ($modal.find('.login-as-message').length > 0) {
					$modal.find('.login-as-message').html(message);
				}

				$modal.find('.login-as-text').html(text);

				$modal.find('.login-as-incognito').click(function loginAs(e) {
					e.preventDefault();

					Adzuki.StatusMessage('Error', 'Please right-click and choose "Open link in incognito window"', 'Use Incognito Window');
				});

				timer = function timer() {
					var text = time_remaining + ' second' + ((time_remaining === 1) ? '' : 's');

					$modal.find('.login-as-time').html(text);

					if (time_remaining === 0) {
						$modal.modal('hide');

						return;
					}

					time_remaining--;

					timer_timeout = setTimeout(timer, 1000);
				};

				timer();
			});
		});
	};

	$(document).ready(function documentReady()
	{
		_init();
	});
}(jQuery, window.Adzuki || {}));
